import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: { type: String, default: "" } }

  copy() {
    const url = this.urlValue || window.location.href

    navigator.clipboard.writeText(url).then(() => {
      const originalText = this.element.textContent
      this.element.textContent = "¡Copiado!"
      setTimeout(() => {
        this.element.textContent = originalText
      }, 2000)
    })
  }
}
